import React, { Component } from 'react';
import {Fab, Paper, Grid, Backdrop, CircularProgress, Avatar, IconButton, Box} from '@material-ui/core/';
import {List, ListItem, ListItemText, ListItemAvatar, ListItemSecondaryAction} from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';
import DeleteIcon from '@material-ui/icons/DeleteOutlined';
import { Receipt } from '@material-ui/icons';
import Title from '../generic/Title';
import {CartaoDialog} from './CartaoDialog';
import {Utils} from '../generic/Utils';
import {ConfirmDialog} from '../util/ConfirmDialog'
import {ExtratoCartao} from './ExtratoCartao'

import axios from 'axios';
import { DateTime } from "luxon";

import '../css/Generic.css'
  
export class ListarCartao extends Component {

    constructor(props) {
        super(props)

        this.state = {
            showNovoDialog: false,
            loading: true,
            confirmDelete: false,
            showExtrato: false,            
            data: DateTime.now(),
            selected: {},
            listaCartoes: [{}]
        }  
        this.handleDelete = this.handleDelete.bind(this)
    }

    componentDidMount() {
        this.buscarLista();
    }

    buscarLista() {
        let userId = sessionStorage.getItem('userId')  
        
        this.setState({loading: true})
        axios.get(Utils.getUrl()+"cartoes/user/"+userId).then(
            resp => {
                if ( resp.status === 201 || resp.status === 200) {
                    let lista = resp.data
                    this.setState({listaCartoes: lista})
                    sessionStorage.setItem("listaCartoes",JSON.stringify(lista));
                }
                else console.log("Erro ao buscar contas")

                this.setState({loading: false})
            }
        ).catch( e => {
            console.log("Erro ao buscar contas "+e) 
            this.setState({loading: false})
        })
    }

    handleDelete() {        

        let conta = this.state.selected
        
        this.setState({loading: true})
        axios.delete(Utils.getUrl()+"cartoes/"+conta._id,).then(
            resp => {
                this.buscarLista();
                this.setState({loading: false, confirmDelete: false})
            }
        ).catch( e => {
            console.log("Erro ao deletar conta "+e) 
            this.setState({loading: false, confirmDelete: false})
        })
    }
    
    render() {
        return(
            <Paper className="class-paper">
                <Title>Seus Cartões</Title>        
                <Grid container spacing={3}>
                    
                    <List className="fullSizeList">
                    {
                        this.state.listaCartoes.map( (e) => 
                            <ListItem>
                                <ListItemAvatar>
                                    <Avatar src={e.icone} variant="rounded"/>
                                </ListItemAvatar>
                                <ListItemText primary={e.apelido} secondary={e.instituicao}/>
                                <ListItemSecondaryAction>
                                    <IconButton>
                                        <EditOutlinedIcon onClick={ () => this.setState({showNovoDialog: true, selected: e}) }/>   
                                    </IconButton>
                                    <IconButton>
                                        <Receipt onClick={ () => this.setState({showExtrato: true, selected: e})  }/>   
                                    </IconButton>
                                    <IconButton onClick={ () => this.setState({confirmDelete: true, selected: e}) }>
                                        <DeleteIcon/>   
                                    </IconButton>
                                </ListItemSecondaryAction>
                            </ListItem>
                        )
                    }
                    </List>

                </Grid>
        
                <div style={{textAlign: "right"}}>
                    <Box m={2} />
                    <Fab color="primary" aria-label="add" onClick={ () => this.setState({showNovoDialog:true, selected: {}}) }>
                        <AddIcon />
                    </Fab>
                </div>

                <CartaoDialog open={this.state.showNovoDialog} 
                    conta={this.state.selected}
                    onSave={ () => this.buscarLista() }
                    onClose={ () => { 
                        this.setState({showNovoDialog:false}) 
                        this.buscarLista()
                    }} />    

                <ExtratoCartao open={this.state.showExtrato}                
                    cartao={this.state.selected}
                    data={this.state.data}
                    onClose={() => this.setState({showExtrato:false})}/>

                <ConfirmDialog open={this.state.confirmDelete}
                    handleClose={ () => this.setState({confirmDelete: false}) }
                    handleOk={this.handleDelete}
                    message="Você deseja realmente excluir a Conta?"
                    />

                <Backdrop
                    style={{ color: '#fff', zIndex: 10000 }}
                    open={this.state.loading}>
                    <CircularProgress color="inherit" />
                </Backdrop>            
            </Paper>
        )
    }
}